document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-addon-btn]');
  if (!btn) return;

  const wrapper = btn.closest('[data-bundle-addon]');
  const select = wrapper.querySelector('[data-addon-select]');
  const variantId = Number(select?.value);
  if (!variantId) return;

  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Lisätään…';

  try {
    const drawer = document.querySelector('cart-drawer');
    const body = { items: [{ id: variantId, quantity: 1 }] };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }

    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.description || 'Virhe');

    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    btn.textContent = 'Lisätty ✓';
  } catch (err) {
    console.error(err);
    btn.textContent = 'Ei onnistunut';
  } finally {
    btn.disabled = false;
    setTimeout(() => { btn.textContent = original; }, 2000);
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-addon-select]');
  if (!select) return;

  const wrapper = select.closest('[data-bundle-addon]');
  const opt = select.selectedOptions?.[0];
  if (!opt) return;

  const priceEl = wrapper.querySelector('[data-addon-price]');
  if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;

  const img = wrapper.querySelector('[data-addon-img]');
  if (img && opt.dataset.img) {
    img.src = opt.dataset.img;
    img.srcset = opt.dataset.img2x ? `${opt.dataset.img} 1x, ${opt.dataset.img2x} 2x` : '';
    if (opt.dataset.imgAlt) img.alt = opt.dataset.imgAlt;
  }

  if (opt.dataset.url) {
    wrapper.querySelectorAll('[data-addon-link]').forEach((link) => {
      link.href = opt.dataset.url;
    });
  }
});